"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabtracShippingRoute_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LabtracLab_1 = require("./LabtracLab");
var LabtracShippingRoute_Factory = /** @class */ (function () {
    function LabtracShippingRoute_Factory() {
    }
    LabtracShippingRoute_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DaysInTransit: model.DaysInTransit,
            ExclusionDays: model.ExclusionDays,
            ExternalId: model.ExternalId,
            LabCode: model.LabCode,
            LabReference: model.LabReference,
            LabtracLab: LabtracLab_1.LabtracLab_Factory.CreateIncoming(model.LabtracLab),
            LabtracLabId: model.LabtracLabId,
            Name: model.Name,
            Price: model.Price,
            PriceIsSpecified: model.PriceIsSpecified,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    LabtracShippingRoute_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DaysInTransit: model.DaysInTransit,
            ExclusionDays: model.ExclusionDays,
            ExternalId: model.ExternalId,
            LabCode: model.LabCode,
            LabReference: model.LabReference,
            LabtracLab: LabtracLab_1.LabtracLab_Factory.CreateOutgoing(model.LabtracLab),
            LabtracLabId: model.LabtracLabId,
            Name: model.Name,
            Price: model.Price,
            PriceIsSpecified: model.PriceIsSpecified,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return LabtracShippingRoute_Factory;
}());
exports.LabtracShippingRoute_Factory = LabtracShippingRoute_Factory;
